import React, { FunctionComponent } from 'react';

import LineSeparator from '@Components/LineSeparator';
import Typography, { HeaderTags, TextTags } from '@Components/Typography';

import styles from './SectionTitle.module.scss';

export interface SectionTitleProps {
  msg: string;
  tag?: TextTags | HeaderTags;
}

const SectionTitle: FunctionComponent<SectionTitleProps> = ({ msg, tag = 'h3' }) => {
  return (
    <div className={styles.container}>
      <Typography msg={msg} tag={tag} />
      <LineSeparator />
    </div>
  );
};

export default SectionTitle;
